// Deliberately all null
// Allows us to update specific fields inline with the process filter and not provide the full object for the update

export class License  {

  id?: string | null;
  extLicenseId?: string | null;
  companyId?: string | null;
  licApplicationId?: string | null;
  name?: string | null;
  description?: string | null;
  sqlConnBespoke?: string | null;
  startDate?: Date | null;
  endDate?: Date | null;
  isActive?: boolean | null;
  enforceEndDate?: boolean | null;
  maxUsers?: number | null;
  enforceUsers?: boolean | null;
  homePage?: string | null;
  osProjectId?: string | null;
  osProjectNumber?: string | null;
  osProjectName?: string | null;
  osContractId?: string | null;
  osOpportunityId?: string | null;
  lastModifiedBy?: string | null;
  lastModifiedOn?: Date | null;

  companyName?: string | null;
  lastModifiedByName?: string | null;
  assignedUsers?: number | null;
}
